export default __webpack_public_path__ + "static/media/2.6696ff29.jpg";